import React from "react";
import { motion } from "framer-motion";

export const GlassCard = React.forwardRef(function GlassCard(
  { children, className = "", strong = false, subtle = false, hover = false, as: Tag = "div", ...rest }, ref
) {
  const cls = strong ? "glass-strong" : subtle ? "glass-subtle" : "glass";
  return (
    <Tag
      ref={ref}
      className={`${cls} noise ${hover ? "lift hover:border-[var(--border-strong)]" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
});

export const AnimatedCard = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);
